import React, { useEffect, useState } from "react";
import http from "../lib/http";

export default function DealerInventoryPage() {
  const [items, setItems] = useState([]);

  const [form, setForm] = useState({
    productName: "",
    category: "",
    brand: "",
    stockQty: "",
    price: ""
  });
  const [editingId, setEditingId] =
  useState(null);

  const dealer =
    JSON.parse(localStorage.getItem("dealer") || "{}");

  const dealerId = dealer._id;

  const loadInventory = async () => {
    try {

      if (!dealerId) return;

      const res = await http.get(
        `/api/inventory/dealer/${dealerId}`
      );

      setItems(res.data);

    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    loadInventory();
  }, []);

  const saveItem = async () => {

    try {

      if (editingId) {

        await http.put(
          `/api/inventory/${editingId}`,
          {
            ...form
          }
        );

      } else {

        await http.post("/api/inventory", {
          ...form,
          dealerId
        });

      }

      resetForm();

      loadInventory();

    } catch (err) {
      console.error(err);
    }
  };

    const resetForm = () => {

    setEditingId(null);

    setForm({
      productName: "",
      category: "",
      brand: "",
      stockQty: "",
      price: ""
    });

  };

  const editItem = (item) => {

  setEditingId(item._id);

  setForm({
    productName: item.productName,
    category: item.category,
    brand: item.brand,
    stockQty: item.stockQty,
    price: item.price
  });

};

const deleteItem = async (id) => {

  if (!window.confirm(
    "Delete this inventory item?"
  )) return;

  await http.delete(
    `/api/inventory/${id}`
  );

  loadInventory();

}; 

  return (
    <div className="container py-4">

      <h3>Inventory Management</h3>

      <div className="card p-3 mb-4">

        <input
          className="form-control mb-2"
          placeholder="Product"
          value={form.productName}
          onChange={(e)=>
            setForm({
              ...form,
              productName:e.target.value
            })
          }
        />

        <input
          className="form-control mb-2"
          placeholder="Category"
          value={form.category}
          onChange={(e)=>
            setForm({
              ...form,
              category:e.target.value
            })
          }
        />

        <input
          className="form-control mb-2"
          placeholder="Brand"
          value={form.brand}
          onChange={(e)=>
            setForm({
              ...form,
              brand:e.target.value
            })
          }
        />

        <input
          type="number"
          className="form-control mb-2"
          placeholder="Stock Qty"
          value={form.stockQty}
          onChange={(e)=>
            setForm({
              ...form,
              stockQty:e.target.value
            })
          }
        />

        <input
          type="number"
          className="form-control mb-3"
          placeholder="Price"
          value={form.price}
          onChange={(e)=>
            setForm({
              ...form,
              price:e.target.value
            })
          }
        />

        <button
          className="btn btn-primary"
          onClick={saveItem}
        >
         {editingId
            ? "Update Inventory"
            : "Save Inventory"}
        </button>

      </div>

      <div className="card p-3">
        <h5>Current Stock</h5>

        <table className="table">
          <thead>
            <tr>
              <th>Product</th>
              <th>Stock</th>
              <th>Price</th>
            </tr>
          </thead>

          <tbody>

          {items.map(item => (

          <tr key={item._id}>

            <td>{item.productName}</td>

            <td>{item.stockQty}</td>

            <td>₹{item.price}</td>

            <td>

              <button
                className="btn btn-sm btn-primary me-2"
                onClick={() => editItem(item)}
              >
                Edit
              </button>

              <button
                className="btn btn-sm btn-danger"
                onClick={() => deleteItem(item._id)}
              >
                Delete
              </button>

            </td>

          </tr>

          ))}

          </tbody>

        </table>
      </div>
    </div>
  );
}